module.exports = __webpack_public_path__ + "giving/public/shared/assets/discover.svg?d423f9ebfd9da1e6462f2e05e25d64df";